// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a5047195","453":"cd7a4898","732":"ec87fbbf","977":"a4e5b2aa"}[chunkId] + ".chunk.js";
};